import instance from '@/services/repository';

const resource = '/machineryStatus';

export default {
    getAll() {
        return instance.get<IMachineryStatus[]>(`${resource}`);
    },
    create(payload: IMachineryStatusCreateCommand) {
        return instance.post<IMachineryStatus>(`${resource}`, payload);
    },
    update(payload: IMachineryStatusUpdateCommand) {
        return instance.put<IMachineryStatus>(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
};
